import React from 'react'
import classNames from 'classnames'
import { slugs } from '@/constants/slugs'
import { Translate } from '@/utils/translate/translate-client'
import { getProjectStyle, createContactSupportAnswer } from '../shared'
import { GiveawayFaq } from '../types'

export const getSeniorFaqs = (): GiveawayFaq[] => [
  {
    key: 'releaseDate',
    question: (t) => t('seniorHowDoIenter', 'How do I enter The Angel Superfan Giveaway?'),
    answer: (t) => (
      <span className={getProjectStyle(slugs.senior)}>
        {t(
          'seniorReleaseDateAnswers',
          'Just pre-order tickets to The Senior, in theaters September 19. Each ticket you buy is an entry—and\n' +
            'the more tickets you buy, the more your entries multiply. Buy early for even bigger multipliers. Both\n' +
            'ways boost your chances to win!',
        )}
      </span>
    ),
  },
  {
    key: 'doIneedTickets',
    question: (t) => t('doINeedTicketsQuestion', 'Do I need to buy tickets to enter?'),
    answer: (t) => (
      <span className={getProjectStyle(slugs.senior)}>
        {t(
          'doINeedTicketsAnswer',
          'No. While buying tickets is the easiest way to enter, you can also enter by mail without purchase. See the Official Rules for instructions on free entry options.',
        )}
      </span>
    ),
  },
  {
    key: 'whatPrizes',
    question: (t) => t('whatPrizesQuestion', 'What prizes can I win?'),
    answer: (t) => (
      <Translate t={t} i18nKey="whatPrizesAnswer">
        <span className={getProjectStyle(slugs.senior)}>Three tiers of prizes are up for grabs:</span>
        <ul className={classNames('flex list-inside list-disc flex-col gap-2', getProjectStyle(slugs.senior))}>
          <li>
            <strong>Grand Prize:</strong> $50,000 cash for you to purchase a VIP Big Game weekend for two.
          </li>
          <li>
            <strong>Weekly Prizes:</strong> $10,000 cash for you to buy season tickets to the college football team of
            your choice. Six lucky winners will be chosen.
          </li>
          <li>
            <strong>Scholarships:</strong> Five winners will receive a full-ride scholarship (tuition, room, board) to
            Sul Ross State University.
          </li>
        </ul>
      </Translate>
    ),
  },
  {
    key: 'giveawayDates',
    question: (t) => t('seniorWhoCanEnter', 'Who can enter?'),
    answer: (t) => (
      <span className={getProjectStyle(slugs.senior)}>
        {t(
          'seniorWhoCanEnterAnswer',
          'The giveaway is open to legal residents of the 50 United States (excluding NY and FL) and the\n' +
            'District of Columbia, who are at least the age of majority in their state at the time of entry.',
        )}
      </span>
    ),
  },
  {
    key: 'giveawayDates',
    question: (t) => t('seniorWhenDoesItEnd', 'When does the giveaway end?'),
    answer: (t) => (
      <span className={getProjectStyle(slugs.senior)}>
        {t(
          'seniorWhenDoesItEndAnswer',
          'Entries are open from July 31, 2025, through October 17, 2025, at 11:59 PM PT. Winners will be selected shortly after and notified via the contact information provided at entry.',
        )}
      </span>
    ),
  },
  {
    key: 'contactSupport',
    question: (t) => t('contactSupportQuestion', 'How do I contact support?'),
    answer: createContactSupportAnswer(slugs.senior),
  },
]
